import get from 'lodash/get'
/**
 * At any point in future, product wants to bring in OLD seti experienced, please refer to ListingsContent/index.js,
 * recommendedbundlesearch.js(API call) and this file in master-1.0.505 tag for code before cleanup of following SETIS
 *  AIR_PKG_XSELL_LISTINGS_CTA
 * AIR_PKG_XSELL_LISTINGS_TARGET
 * AIR_HOTEL_AD
 * AIR_PKGS_XSELL_START_RATING_TAKE2
 * AIR_PKGS_XSELL_SAVINGS_PERCENT
 * AIR_PKG_AD_LISTINGS_REC_HOTEL
 * */

function isCrossSellDisplayed(PCLN_BOOTSTRAP_DATA) {
  const numberOfPassengers = get(PCLN_BOOTSTRAP_DATA, 'searchRequest.numberOfPassengers', 1)
  const searchCabinClass = get(PCLN_BOOTSTRAP_DATA, "searchRequest.params['cabin-class']", 'ECO')
  const isRoundTrip = get(PCLN_BOOTSTRAP_DATA, 'isRoundTrip', false)

  // packages not existent for non RT itins and for searches with
  // more than 8 passengers - including lap infants
  return isRoundTrip && searchCabinClass === 'ECO' && !!numberOfPassengers && numberOfPassengers <= 8
}

export function handlePackageCrossSell(pclnBootstrapData, flySearchResponseData) {
  const numberOfPassengers = get(pclnBootstrapData, 'searchRequest.numberOfPassengers')
  const isCrossSell = isCrossSellDisplayed(pclnBootstrapData)

  const pkgCrossSellInfo = {
    numberOfPassengers,
    isCrossSell,
  }

  if (isCrossSellDisplayed) {
    pkgCrossSellInfo.slices = pclnBootstrapData.searchRequest.slices.map((slice) => {
      slice = { ...slice }
      const { originAirport, destinationAirport } = slice

      slice.originCityName = getAirportCityName(originAirport, pclnBootstrapData, flySearchResponseData)
      slice.destinationCityName = getAirportCityName(
        destinationAirport,
        pclnBootstrapData,
        flySearchResponseData
      )

      return slice
    })

    pkgCrossSellInfo.params = pclnBootstrapData.searchRequest.params
  }

  return pkgCrossSellInfo
}

export function getAirportCityName(airportCode, pclnBootstrapData, flySearchResponseData = {}) {
  const airportsMap = get(pclnBootstrapData, 'searchRequest.airports', {})
  const { cityName, stateCode, countryCode } = airportsMap[airportCode] || {}

  const { airports } = flySearchResponseData
  const { city, state, country } = (airports?.length > 0 && airports?.[airportCode]) || {}

  // try and get full country info from the airportTable but if doesn't match - use code from airportsMap
  return `${city || cityName}, ${state || stateCode || country || countryCode}`
}
